import axios from 'axios';
import { axiosETAGCache } from 'axios-etag-cache';

let globalAvailableActions = null;
let globalAgentActionSchema = null;
let globalAgentSchema = null;
let globalTaskSchema = null;

// Apply the axios ETAG interceptor
const axiosWithETAGCache = axiosETAGCache(axios);
const api = {
  async getAgentActionSchema() {
    if (globalAgentActionSchema) {
      return globalAgentActionSchema;
    }
    const response = await axiosWithETAGCache.get(`/agent_action/schema`);
    globalAgentActionSchema = response.data;
    return response.data;
  },
  async getAgentActions(tableQuery) {
    const queryParams = {
      query: JSON.stringify(tableQuery),
    };

    const response = await axiosWithETAGCache.get(`/agent_action`, {
      params: queryParams,
    });

    return response.data;
  },
  async createNewAgentAction(newAgentActionData) {
    const response = await axios.post(`/agent_action`, newAgentActionData);

    return response.data;
  },
  async getAgentAction(agentActionId) {
    const queryParams = {};

    const response = await axiosWithETAGCache.get(
      `/agent_action/${agentActionId}`,
      {
        params: queryParams,
      }
    );

    return response.data;
  },
  async saveAgentAction(agentAction) {
    const response = await axios.put(
      `/agent_action/${agentAction.id}`,
      agentAction
    );
    return response.data;
  },
  async deleteAgentAction(agentActionId) {
    const response = await axios.delete(`/agent_action/${agentActionId}`);

    return response.data;
  },
  async getAvailableActions() {
    if (globalAvailableActions) {
      return globalAvailableActions;
    }
    const response = await axiosWithETAGCache.get(`/available_actions`);
    globalAvailableActions = response.data;
    return response.data;
  },
  async getAgentSchema() {
    if (globalAgentSchema) {
      return globalAgentSchema;
    }
    const response = await axiosWithETAGCache.get(`/agent/schema`);
    globalAgentSchema = response.data;
    return response.data;
  },
  async getAgents(tableQuery) {
    const queryParams = {
      query: JSON.stringify(tableQuery),
    };

    const response = await axiosWithETAGCache.get(`/agent`, {
      params: queryParams,
    });

    return response.data;
  },
  async createNewAgent(newAgentData) {
    const response = await axios.post(`/agent`, newAgentData);

    return response.data;
  },
  async getAgent(agentId) {
    const queryParams = {};

    const response = await axiosWithETAGCache.get(`/agent/${agentId}`, {
      params: queryParams,
    });

    return response.data;
  },
  async saveAgent(agent) {
    const response = await axios.put(`/agent/${agent.id}`, agent);
    return response.data;
  },
  async deleteAgent(agentId) {
    const response = await axios.delete(`/agent/${agentId}`);

    return response.data;
  },

  async getTaskSchema() {
    if (globalTaskSchema) {
      return globalTaskSchema;
    }
    const response = await axiosWithETAGCache.get(`/task/schema`);
    globalTaskSchema = response.data;
    return response.data;
  },
  async getTasks(tableQuery) {
    const queryParams = {
      query: JSON.stringify(tableQuery),
    };

    const response = await axiosWithETAGCache.get(`/task`, {
      params: queryParams,
    });

    return response.data;
  },
  async createNewTask(newTaskData) {
    const response = await axios.post(`/task`, newTaskData);

    return response.data;
  },
  async getTask(taskId) {
    const queryParams = {};

    const response = await axiosWithETAGCache.get(`/task/${taskId}`, {
      params: queryParams,
    });

    return response.data;
  },
  async saveTask(task) {
    const response = await axios.put(`/task/${task.id}`, task);
    return response.data;
  },
  async deleteTask(taskId) {
    const response = await axios.delete(`/task/${taskId}`);

    return response.data;
  },
};

export default api;
